module.exports = __webpack_public_path__ + "static/media/profile-1.3894ef36.jpg";